import React, { useState } from 'react'
import { BsStars } from 'react-icons/bs';
import { FaCloudUploadAlt, FaRegQuestionCircle } from "react-icons/fa";
import { Link } from 'react-router';
// import DownloadFormatModal from './DownloadFormatModal';

const EssayPreviewPage = () => {
    const [showModal, setShowModal] = useState(false);
    return (
        <div className='p-4 flex flex-col items-center gap-4'>
             <div className=' w-full'>

<p className='flex text-2xl font-medium items-start' >Essay Details</p>
</div>
            <div className='flex flex-row items-center justify-between pl-3 pr-3 gap-4 bg-gray-200 h-[70px] rounded-lg border border-blue-500 w-full'>
                <div>
                    <p className='font-medium'>Subject: <span className='font-medium text-blue-400'>English</span></p>
                </div>
                <div>
                    <p className='font-medium'>Topic: <span className='font-medium text-blue-400'>Creative Writing</span></p>
                </div>
                <div>
                    <p className='font-medium'>Essay Completion Time: <span className='font-medium text-blue-400'>42 Days</span></p>
                </div>
                <div>
                    <p className='font-medium'>Graded:<span className='font-medium text-red-500'>No</span></p>
                </div>

                <div className='flex flex-row gap-4 items-center'>
                    <p className='font-medium'>Supervisor</p>
                    <div className='flex flex-col '>
                        <img
                            src={require("../../../assets/Profile Picture.png")}
                            alt="Profile"
                            className="w-10 h-10 rounded "
                        />
                        <p className='text-[12px] text-blue-400'>View Details</p>
                    </div>
                </div>

            </div>
           
            <div className='flex  flex-col border border-gray-300 h w-full rounded-lg p-4 '>
                <div className='flex flex-row-reverse w-full '>
                    <div className=' h-[30px] px-2 rounded-lg text-blue-400 flex  bg-gray-200 border border-blue-300 items-center gap-2'>
                        <FaRegQuestionCircle />Support Chats</div>
                </div>
                <div className='flex items-center justify-between py-2'>
                    <p className='flex text-2xl font-medium'>Research Question & Problem Statement</p>
                    <div className='flex flex-row-reverse'>
                        <p className='font-medium'>Total Time Remaining: <span className='font-medium text-yellow-500'>41 Days 23:23</span></p>
                    </div>
                </div>
                <div>
                    <textarea type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestiae quisquam officia autem. In, tempora ut assumenda quam numquam excepturi fuga minima expedita voluptas iste molestiae amet, consequatur praesentium adipisci necessitatibus.
           Nihil itaque, reprehenderit doloremque sit maxime ipsum? At minus ipsam distinctio ex quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.'  className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                    <p className=' flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                </div>
                <div>
                    <div className='flex w-full items-center justify-between mt-4 gap-4'>
                        <div className='flex flex-col w-[50%] gap-2 '>
                            <label className='font-medium'>Feedback 1</label>
                            <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2   placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                            <div className='flex flex-row-reverse'>
                                {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[120px]'>Get Feedback</button> */}
                            </div>
                        </div>
                        <div className='flex flex-col w-[50%] gap-2'>
                            <label htmlFor="text" className='font-medium'>Feedback 2</label>
                            <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                            <div className='flex flex-row-reverse'>
                                {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[120px]'>Get Feedback</button> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='flex items-center justify-between py-2'>
                        <p className='flex text-2xl font-medium'>Preparatory Reading and Planning</p>
                        <div className='flex flex-row-reverse'>
                            <p className='font-medium'>Total Time Remaining: <span className='font-medium text-yellow-500'>41 Days 23:23</span></p>
                        </div>
                    </div>
                    <div>
                        <textarea type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestiae quisquam officia autem. In, tempora ut assumenda quam numquam excepturi fuga minima expedita voluptas iste molestiae amet, consequatur praesentium adipisci necessitatibus.
           Nihil itaque, reprehenderit doloremque sit maxime ipsum? At minus ipsam distinctio ex quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.'  className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                        <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                    </div>
                    <div>
                        <div className='flex w-full items-center justify-between mt-4 gap-4'>
                            <div className='flex flex-col w-[50%] gap-2 '>
                                <label htmlFor="text" className='font-medium'>Feedback 1</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='flex flex-row-reverse items-center gap-3'>
                                    {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Get Feedback</button> */}
                                    {/* <button className='bg-blue-600 text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Download Attachment</button> */}
                                    {/* <button className='bg-blue-600 text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Download Attachment</button> */}


                                </div>
                            </div>
                            <div className='flex flex-col w-[50%] gap-2 '>
                                <label htmlFor="text" className='font-medium'>Feedback 2</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='flex flex-row-reverse items-center gap-3'>
                                    {/* <button className='bg-gray-400 text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Download Attachment</button> */}


                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div>
                    <div className='flex items-center justify-between py-2'>
                        <p className='flex text-2xl font-medium'>Outline and Methodology Development
                        </p>
                        <div className='flex flex-row-reverse'>
                            <p className='font-medium'>Total Time Remaining: <span className='font-medium text-yellow-500'>41 Days 23:23</span></p>
                        </div>
                    </div>
                    <div>
                        <textarea type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestiae quisquam officia autem. In, tempora ut assumenda quam numquam excepturi fuga minima expedita voluptas iste molestiae amet, consequatur praesentium adipisci necessitatibus.
           Nihil itaque, reprehenderit doloremque sit maxime ipsum? At minus ipsam distinctio ex quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.'  className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                        <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                    </div>
                    <div>
                        <div className='flex w-full items-center justify-between mt-4 gap-4'>
                            <div className='flex flex-col w-[50%] gap-2 '>
                                <label htmlFor="text" className='font-medium'>Feedback 1</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='flex flex-row-reverse items-center gap-3'>
                                    {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Get Feedback</button> */}
                                    {/* <button className='bg-blue-600 text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Download Attachment</button> */}
                                    {/* <button className='bg-blue-600 text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Upload Attachment</button> */}


                                </div>
                            </div>
                            <div className='flex flex-col w-[50%] gap-2 '>
                                <label htmlFor="text" className='font-medium'>Feedback 2</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='flex flex-row-reverse items-center gap-3'>
                                    {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Get Feedback</button> */}
                                    {/* <button className='bg-blue-600 text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Download Attachment</button> */}
                                    {/* <button className='bg-blue-600 text-white py-1.5  rounded-lg w-[150px] text-nowrap text-sm'>Upload Attachment</button> */}


                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='border border-gray-300 rounded-lg p-4 mt-4'>
                    <div className='flex items-center justify-between py-2'>
                        <div>
                            <p className=' gap-2 text-2xl font-medium items-center'>Drafting The Essay
                                <span className='text-gray-500 text-[16px] ml-3'>Total Words : 1500/ 2000</span>
                            </p>
                            <p className='text-gray-400'>This is where the main body of your essay goes. Expand on your points with evidence and examples. Break the essay into logical sections: Introduction, Methodology, Analysis, and Conclusion. Use subheadings where necessary for clarity.
                                Write the main part of your essay here. Explain your points and give examples to support them.</p>
                        </div>
                        <div className='flex flex-row-reverse'>
                        </div>
                    </div>
                    <div className='flex flex-col items-center gap-3 w-full'>
                        <div className='w-full'>
                            <p className='text-2xl font-medium mb-2 flex justify-between'>Title: <span>
                                <p className='font-medium text-nowrap text-[16px]'>Total Time Remaining: <span className='font-medium text-yellow-500'>41 Days 23:23</span></p>
                            </span></p>
                            <input type="text" placeholder=' Lorem ipsum dolor, quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.' className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                            <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                        </div>
                        <div className='w-full'>
                            <p className='text-2xl font-medium mb-2'>Contents:</p>
                            <input type="text" placeholder=' Lorem ipsum dolor, quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.' className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                            <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                        </div>
                        <div className='w-full'>
                            <p className='text-2xl font-medium mb-2'>Background:</p>
                            <input type="text" placeholder=' Lorem ipsum dolor, quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.' className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                            <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                        </div>
                        <div className='w-full'>
                            <p className='text-2xl font-medium mb-2'>Introduction:</p>
                            <input type="text" placeholder=' Lorem ipsum dolor, quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.' className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                            <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                        </div>
                        <div className='w-full'>
                            <p className='text-2xl font-medium mb-2'>Methodology:</p>
                            <input type="text" placeholder=' Lorem ipsum dolor, quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.' className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                            <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                        </div>
                        <div className='w-full'>
                            <p className='text-2xl font-medium mb-2'>Body Of The Essay <span className='text-gray-400 text-lg'>(Critical Analysis and Argument):</span></p>
                            <input type="text" placeholder=' Lorem ipsum dolor, quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.' className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                            <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                        </div>
                        <div className='w-full'>
                            <p className='text-2xl font-medium mb-2'>Conclusion:</p>
                            <input type="text" placeholder=' Lorem ipsum dolor, quasi beatae doloribus illo praesentium eius, delectus, veritatis vitae facilis nostrum, odio ipsa esse soluta? Maiores, autem et.' className='p-2  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg w-full' />
                            <p className='w-full flex items-center justify-end mt-[-30px] pr-4'>0/100</p>
                        </div>

                    </div>


                </div>
                <div>
                    <div>
                        <div className='flex w-full items-center justify-between mt-4 gap-4'>
                            <div className='flex flex-col w-[50%] gap-2 '>
                                <label htmlFor="text" className='font-medium'>Feedback 1</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='flex flex-row-reverse'>
                                    {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[120px]'>Get Feedback</button> */}
                                </div>
                            </div>
                            <div className='flex flex-col w-[50%] gap-2'>
                                <label htmlFor="text" className='font-medium'>Feedback 2</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='flex flex-row-reverse'>
                                    {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[120px]'>Get Feedback</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='flex w-full items-center justify-between mt-4 gap-4'>
                            <div className='flex flex-col w-[50%] gap-2 '>
                                <label htmlFor="text" className='font-medium'>Feedback 3</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='flex flex-row-reverse items-center gap-4'>
                                    {/* <button className='bg-[#FF9348] text-white py-1.5  rounded-lg w-[120px]'>Get Feedback</button> */}
                                    <button className='bg-[#683FEA] text-white py-1.5  rounded-lg w-[120px] text-nowrap flex items-center justify-center gap-2'> AI Grades<BsStars /> </button>

                                </div>
                            </div>
                            <div className='flex flex-col w-[50%] gap-2'>
                                <label htmlFor="text" className='font-medium'>Feedback 4</label>
                                <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='     placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                                <div className='h-[35px]'></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex flex-col '>
                    <p className='text-2xl font-medium'>Versions:</p>
                    <div className='flex gap-4 items-center '>
                        <p className='text-blue-400 underline'>Initial Draft</p>
                        <p className='text-blue-400 underline'>Second Draft</p>
                        <p className='text-blue-400 underline'>Final Essay</p>

                    </div>
                </div>
                <div>

                </div>
                <div className='w-full space-y-4 p-4'>
                    <p className='text-2xl font-medium'>Appendencies : <span className='text-[16px] text-gray-400'>(Optional)</span></p>

                    <div className='flex gap-4 items-center w-full '>
                        <p className='text-xl font-medium text-nowrap'>Reference And Bibliography:</p>
                        <input type="text" placeholder=' Lorem ipsum dolor, sit amet consectetur adipisicing elit.' className='p-2 w-full  placeholder:text-wrap h-[80px] border border-gray-300 rounded-lg ' />
                    </div>

                </div>
                <div className="w-full flex gap-12 items-start justify-start">
                    <p className="text-xl font-medium whitespace-nowrap mb-2 ml-4">Upload Files:</p>
                    <div className="flex flex-wrap gap-4 items-start">
                        {[...Array(3)].map((_, index) => (
                            <div
                                key={index}
                                className="w-[300px] h-[200px] border border-gray-300 border-dashed rounded-lg flex flex-col items-center justify-center p-4 text-center cursor-pointer relative"
                            >
                                <FaCloudUploadAlt className="text-blue-600 text-3xl mb-2" />
                                <p className="text-sm">
                                    <span className="font-medium ">Upload a file </span> or drag and drop
                                </p>
                                <p className="text-xs text-gray-400">
                                    PNG, JPG, PDF, DOC, MP4, MKV up to 10MB
                                </p>
                                <input
                                    type="file"
                                    className="absolute w-full h-full opacity-0 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>
                </div>

                {/* main */}
            </div>
            <div className='flex  justify-between w-full gap-4 '>
                <div className='flex flex-row items gap-3'>
              <Link to={"/supervisor/dashboard"}> <button className=' text-blue-600 h-[40px] text-nowrap border border-blue-600   rounded-lg w-[150px]'>Back To Dashboard</button></Link> 
                <button className=' text-blue-600 border h-[40px] text-nowrap border-blue-600   rounded-lg w-[150px]'>Go Back</button>
                </div>
                <span>
                    <button onClick={() => setShowModal(true)} className='  bg-blue-600 h-[40px] text-nowrap text-white   rounded-lg w-[150px]'>Download Essay</button>
                    </span>
            </div>

            {/* {
            showModal && (
                <DownloadFormatModal onClose={() => setShowModal(false)} />
            )   
           } */}

        </div>
    )
}

export default EssayPreviewPage